// import Navlink from "../../component/navlink/Navlink";

const Offshore = ({ children }) => {
  return (
    <>
      {/* <Navlink /> */}
      {children}
    </>
  );
};

export default Offshore;
